import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Product, ProductService, RoutingService, VariantOption } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { ProductScope } from 'src/app/model/product-scope.model';
// import { ProductScope } from '../../../../model/product-scope.model';

@Injectable({
  providedIn: 'root',
})
export class ProductVariantGuard {
  constructor(private productService: ProductService, private routingService: RoutingService) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.routingService.getRouterState().pipe(
      map((state) => state.nextState.params.productCode),
      switchMap((productCode: string) => {
        if (Boolean(productCode)) {
          return this.productService.get(productCode, ProductScope.VARIANTS);
        } else {
          return of(undefined);
        }
      }),
      map((product: Product) => {
        if (Boolean(product) && !product.purchasable) {
          if (product.variantOptions) {
            const variant = this.findVariant(product.variantOptions);
            // below call might looks redundant but in fact this data is going to be loaded anyways
            // we're just calling it earlier and storing
            this.productService
              .get(variant.code, ProductScope.LIST)
              .pipe(filter(Boolean), take(1))
              .subscribe((_product: Product) => {
                this.routingService.go({
                  cxRoute: 'product',
                  params: _product,
                });
              });
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      })
    );
  }

  findVariant(variants: VariantOption[]): VariantOption {
    const results: VariantOption[] = variants.filter((variant) => {
      return variant.stock && variant.stock.stockLevel ? variant : false;
    });
    return !results.length && variants.length ? variants[0] : results[0];
  }
}
